import React from 'react';
import Filter from '../Filter'

type Iprops = {
    
    total?: number | string
    lastTitle?: string
    pClassName?: string
    firstTitle?: string
    onSubmit?: (beds: string, source: string) => void
}

function TotalShow(props: Iprops) {
  const {
    total = 0,
    pClassName,
    lastTitle = ' houses for you',
    firstTitle = 'We found ',
    onSubmit,
  } = props
  return (
    <div className={`flex items-center justify-between mb-[12px]  ${pClassName} select-none`}>
        <span className=' font-Poppins text-2xs font-[400] not-italic'>
          <i className='not-italic'>{firstTitle}</i>
          <i className=' text-blue not-italic'>{total}</i>
          <i className='not-italic'>{lastTitle}</i>
        </span>
        <div>
          <Filter
            onSubmit={onSubmit}
          />
        </div>
    </div>
  );
}

export default TotalShow;
